import RecipeResult from 'containers/computers/result/Result';
import enhance from 'containers/computers/result/Result.enhancer';

export default enhance(RecipeResult);
